module.exports = __webpack_public_path__ + "img/apogee-logo.acecc6e3.png";